import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('line_items'),
    accountColName: defineMessage('account'),
    debitColName: defineMessage('debit'),
    creditColName: defineMessage('credit'),
    descriptionColName: defineMessage('description'),
    taxColName: defineMessage('tax'),
    taxAmountColName: defineMessage('tax_amount'),
    numberColName: defineMessage('unknown_text_11'),
    debitTitle: defineMessage('debit'),
    creditTitle: defineMessage('credit'),
    totalTitle: defineMessage('total'),
    subtotalTitle: defineMessage('subtotal'),
    taxInclusiveText: defineMessage('amounts_are_tax_inclusive_1'),
    taxExclusiveText: defineMessage('amounts_are_tax_exclusive_1'),
};
